import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import Footer from "../components/Footer";
import { Navbar } from "flowbite-react";
import apiClient from "../components/apiClient";
import { useParams } from "react-router-dom";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});

const BlogDetail = () => {
  const { id } = useParams();
  const [detailblogs, setDetailBlogs] = useState([]);

  useEffect(() => {
    const fetchHighlightBlogs = async () => {
      try {
        // const res = await apiClient.get(`/blog/show/highlight/${id}`);
        const res = await apiClient.get(`/blog/${id}`);
        console.log("API Response:", res.data); // 🔍 add this
        setDetailBlogs(res.data.blog || []);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchHighlightBlogs();
  }, [id]);

  if (!detailblogs) {
    return <p className="text-center mt-10 text-gray-600">Loading blog...</p>;
  }

  return (
    <>
      <Navbar />
      <div className="p-4 mt-8 flex flex-col order-2 md:order-1">
        <h1 className="flex justify-center text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-3 leading-tight">
          {detailblogs.judul}
        </h1>
        <div className="flex flex-col items-center">
          <img
            src={detailblogs.image}
            alt="Blog Detail"
            className="object-cover rounded-lg 
               w-full max-w-[466px] h-auto 
               md:w-[466px] md:h-[472px]"
          />
          <span className="text-sm md:text-base text-gray-500 mb-2">
            {new Date(detailblogs.createdAt).toLocaleDateString("id-ID", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>

        {/* Render rich HTML from blog.detail */}
        <div
          className="ck-content whitespace-pre-wrap text-gray-700"
          dangerouslySetInnerHTML={sanitizeHTML(
            detailblogs.detail || "No description available."
          )}
        />
      </div>

      <Footer />
    </>
  );
};
export default BlogDetail;
